export const CustomRevisionMaterialData = [{
    id: 1,
    subjectName: 'shortnotes',
    title: 'Shortnotes',
    count: 851,
},
{
    id: 2,
    subjectName: 'formula',
    title: 'Formula',
    count: 365,
},
{
    id: 3,
    subjectName: 'videos',
    title: 'Videos',
    count: 452,
},
{
    id: 4,
    subjectName: 'constants',
    title: 'Constants',
    count: 448,
},
{
    id: 5,
    subjectName: 'shapes',
    title: 'Shapes',
    count: 851,
},
{
    id: 6,
    subjectName: 'reactions',
    title: 'Reactions',
    count: 851,
},
{
    id: 7,
    subjectName: 'numericals',
    title: 'Numericals',
    count: 851,
},
{
    id: 8,
    subjectName: 'exceptions',
    title: 'Exceptions',
    count: 365,
},
{
    id: 9,
    subjectName: 'diagrams',
    title: 'diagrams',
    count: 452,
},
{
    id: 10,
    subjectName: 'namedreactions',
    title: 'Named Reactions',
    count: 448,
},
{
    id: 11,
    subjectName: 'abbreviation',
    title: 'Abbreviation',
    count: 851,
},
{
    id: 12,
    subjectName: 'importantpoints',
    title: 'Important Points',
    count: 851,
},
{
    id: 13,
    subjectName: 'formuladerviation',
    title: 'Formula Derviation',
    count: 851,
},
{
    id: 14,
    subjectName: 'graph',
    title: 'Graph',
    count: 365,
},
{
    id: 15,
    subjectName: 'examples',
    title: 'Examples',
    count: 452,
},
{
    id: 16,
    subjectName: 'properties',
    title: 'Properties',
    count: 448,
},
{
    id: 17,
    subjectName: 'scientiest',
    title: 'Scientiest',
    count: 851,
},
{
    id: 18,
    subjectName: 'definition',
    title: 'Definition',
    count: 851,
},
{
    id: 19,
    subjectName: 'differences',
    title: 'Differences',
    count: 851,
},
{
    id: 20,
    subjectName: 'experiment',
    title: 'Experiment',
    count: 365,
},
{
    id: 21,
    subjectName: 'chemicalcomposition',
    title: 'Chemical Composition',
    count: 452,
},
{
    id: 22,
    subjectName: 'reactionsmechanisms',
    title: 'Reactions Mechanisms',
    count: 448,
},
{
    id: 23,
    subjectName: 'tipsshortcuts',
    title: 'Tips & Shortcuts',
    count: 851,
}
];
